import { z } from "zod/v4";

import { UserInterfaceDtoSchema } from "../../../dtos/user-interfaces";

export const GetUserInterfacesResponseBodySchema = z.object({
  userInterfaces: UserInterfaceDtoSchema.array(),
});

export type GetUserInterfacesResponseBodyType = z.infer<
  typeof GetUserInterfacesResponseBodySchema
>;

export const GetUserInterfacesPathParamsSchema = z.object({
  variationId: z.uuid(),
});
export type GetUserInterfacesPathParamsType = z.infer<
  typeof GetUserInterfacesPathParamsSchema
>;
